type ComparerFn<T> = (lhs: T, rhs: T) => boolean;

/**
 * Check if the value is any of the comparands.
 * @param value The value to check.
 * @param eq The comparer function.
 * @param comparands The comparands to check against.
 *
 * @example
 * isAnyOf('a', 'a', 'b', 'c'); // true
 * isAnyOf('a', (lhs, rhs) => lhs === rhs, 'a', 'b', 'c'); // true
 *
 */
export function isAnyOf<T>(value: T, eq: ComparerFn<T>, ...comparands: T[]): boolean;
export function isAnyOf<T>(value: T, ...comparands: T[]): boolean;
export function isAnyOf<T>(value: T, comparandOrFn: ComparerFn<T> | T, ...comparands: T[]): boolean {
  let eq: ComparerFn<T> = (lhs: T, rhs: T) => lhs === rhs;
  if (typeof comparandOrFn === 'function') {
    eq = comparandOrFn as ComparerFn<T>;
  } else {
    comparands.unshift(comparandOrFn);
  }

  for (const comparand of comparands) {
    if (eq(value, comparand)) return true;
  }

  return false;
}
